import React, { forwardRef } from "react";
import Icon from "./Icon";
const ClickButton = forwardRef(({ className, isText, styles, label, color = "#fff", icon, size = 20, onClick }, ref) => {
    return (React.createElement("div", { ref: ref, style: styles, className: `click_button ${className} ${isText ? "text-button" : ""} ${color ? "no-color" : ""}`, onClick: onClick },
        icon && React.createElement(Icon, { icon: icon, size: size, color: color }),
        label && (React.createElement("span", { className: "overText", style: { ...(styles?.text || {}) } }, label))));
});
export default ClickButton;
